module.exports = __webpack_public_path__ + "img/ig.f6302372.svg";